import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./delete-documents-confirmation-dialog.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./delete-documents-confirmation-dialog.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
export let DeleteDocumentsConfirmationDialogComponent = class DeleteDocumentsConfirmationDialogComponent {
    activeModal;
    dialogTitle;
    documentsToDelete;
    cancelBtnPlaceholder = "Cancel";
    saveBtnPlaceholder = "Delete";
    dialogMessage = "Are you sure that you want to delete the selected document(s) from the table?";
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    ngOnInit() {
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onDeleteBtnClicked() {
        this.activeModal.close(this.documentsToDelete);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        documentsToDelete: [{ type: Input }]
    };
};
DeleteDocumentsConfirmationDialogComponent = __decorate([
    Component({
        selector: "app-delete-documents-confirmation-dialog",
        template: __NG_CLI_RESOURCE__0,
        host: { 'delete-documents-confirmation-dialog': 'view-application' },
        styles: [__NG_CLI_RESOURCE__1]
    })
], DeleteDocumentsConfirmationDialogComponent);
